import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import contactBg from '../assets/images/contact-bg.png';
import Counter from '../components/Counter';
import ExpertLeaderTestimonial from '../components/ExpertLeaderTestimonial'
import ceoBg from '../assets/images/bg.png';
import { useWebContent } from '../hooks/useWebContent';
// Elements Images
import element1 from '../assets/images/ceo-element1.png';
import element2 from '../assets/images/ceo-element2.png';
import ceoImage from '../assets/images/ceo-image.png';
import clientReview from '../assets/images/client-review.png';
import companyImg from '../assets/images/comapny-img.png';
import coreImg1 from '../assets/images/core1.png';
import coreImg2 from '../assets/images/core2.png';
import coreImg3 from '../assets/images/core3.png';
import whyImg from '../assets/images/best-img.png';
import checkIcon from '../assets/images/check-icon.png';
import Testimonial from '../components/Testimonial';
import messageIcon from '../assets/images/message.png';
import thumbIcon from '../assets/images/testimonial-element.png';
import testimonialBg from '../assets/images/client-bgimg.png';
import overviewElement from '../assets/images/star-symbol.svg';
import aboutImg from '../assets/images/about-img.png';
import { useUpdateHeadTags } from '../hooks/useUpdateHeadTags';
import { useAdverts } from '../hooks/useAdverts';
import AdvertPopup from '../components/AdvertPopup';

// Expert Leaders Images
import expertImg1 from '../assets/images/expert1.png';
import expertImg2 from '../assets/images/expert2.png';
import expertImg3 from '../assets/images/expert3.png';

// Modal Popup Images
import videoImg from '../assets/images/about-vd.png';
import playButton from '../assets/images/play-button.png';

//Download App Section
import appBg from '../assets/images/download-bg.png';
import dwnRightImg from '../assets/images/download-img.png';
import dwn1 from '../assets/images/dwn1.png';
import dwn2 from '../assets/images/dwn2.png';
import element5 from '../assets/images/star-symbol.svg';
import SectionHeading from '../components/SectionHeading';

//Import SVG Icons
import {  AboutBannerSVG, AboutCeoSVG ,AboutCheckSVG, AboutVideoSVG, DownloadAppSVG , StarElementSVG } from '../components/SvgIcons';

const About = () => {
  const { headers, headersLoading } = useUpdateHeadTags('about-us');
  // Animation
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Modal Popup
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // Fetch web content
  const { data: webContent, isLoading, isError } = useWebContent();

  // Extract about-us-heading-section data
  const aboutSection = webContent?.dataset?.data?.['about-us-heading-section']?.json_data;
  const ceoSection = webContent?.dataset?.data?.['about-us-downloads-section']?.json_data;
  const companyOverviewSection = webContent?.dataset?.data?.['about-us-company-overview']?.json_data;
  const whyBestSection = webContent?.dataset?.data?.['about-us-why-best']?.json_data;
  const reviewsSection = webContent?.dataset?.data?.['about-us-reviews-section']?.json_data;
  const storySection = webContent?.dataset?.data?.['about-us-story-section']?.json_data;
  const teamMembersSection = webContent?.dataset?.data?.['about-us-team-members-section']?.json_data;
  const downloadAppSection = webContent?.dataset?.data?.['download-app-section']?.json_data;

  // Fallback data

  const fallbackTeamMembersSection = {
    heading_text: 'TEAM MEMBERS',
    title: 'Our Expert Leaders',
    small_description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
    team_members: [
      {
        name: 'Willium Smith',
        position: 'CEO & Co-Founder',
        image: 'https://via.placeholder.com/300x400',
        social_links: {
          facebook: '#',
          twitter: '#',
          instagram: '#'
        }
      },
      {
        name: 'Jack Deo',
        position: 'Business Developer',
        image: 'https://via.placeholder.com/300x400',
        social_links: {
          facebook: '#',
          twitter: '#',
          instagram: '#'
        }
      },
      {
        name: 'Mark Nell',
        position: 'Senior Lead',
        image: 'https://via.placeholder.com/300x400',
        social_links: {
          facebook: '#',
          twitter: '#',
          instagram: '#'
        }
      }
    ]
  };

  const fallbackDownloadAppSection = {
    heading_text: 'DOWNLOAD APP',
    title: 'Download app to manage customers',
    small_description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
    section_image: 'https://via.placeholder.com/400x600',
    buttons: [
      {
        url: '#',
        text: 'Download on App Store',
        image: dwn1,
      },
      {
        url: '#',
        text: 'Get on Google Play',
        image: dwn2,
      }
    ]
  };

  const fallbackAboutSection = {
    heading_text: 'ABOUT US',
    title: 'A smart mobile application bring growth opportunities to customers.',
    small_description:
      'MCQs, Notes, Tests & Lectures for All Competitive Exams',
  };

  const fallbackCeoSection = {
    heading_text: 'Message from CEO',
    title: 'Welcome to our growth app! Empowering you with financial control and personalized insights. Secure, seamless, and smart. Let\'s navigate prosperity together.',
    section_image: ceoImage,
    section_review: {
      text: '5000+ Happy Clients',
      link_text: 'Read all reviews',
      url: '/blog',
    },
  };

  const fallbackCompanyOverviewSection = {
    heading_text: 'COMPANY OVERVIEW',
    title: 'Unleash your business growth freedom with App. Gteway to smarter management.',
    small_description:
      'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
    button_text: 'GET STARTED',
    button_url: '',
    section_image: companyImg,
  };

  // Fallback for Core Value section
  const fallbackCoreValues = [
    {
      title: 'Core Values',
      description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      image: coreImg1,
    },
    {
      title: 'Our Vision',
      description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      image: coreImg2,
    },
    {
      title: 'Our Mission',
      description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      image: coreImg3,
    },
  ];

  // Dynamic Core Values data (using sliders from about-us-company-overview for Vision and Mission)
  // FIX: Added !Array.isArray check to prevent .map on non-arrays
  const coreValues = isError || !companyOverviewSection || !companyOverviewSection.sliders || !Array.isArray(companyOverviewSection.sliders) || companyOverviewSection.sliders.length < 3
    ? fallbackCoreValues
    : companyOverviewSection.sliders.map((slider, index) => ({
      title: slider.title || fallbackCoreValues[index].title,
      description: slider.description || fallbackCoreValues[index].description,
      image: slider.image || fallbackCoreValues[index].image,
    }));

  // Fallback for Why Best section
  const fallbackWhyBestSection = {
    heading_text: 'WHY WE ARE BEST',
    title: 'You are in a good hand for your growth.',
    small_description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
    button_text: 'GET STARTED',
    button_url: '',
    section_image: whyImg,
    sliders: [
      { title: 'Vidyakasam – Smart Exam Prep' },
      { title: 'MCQs, Notes, Tests & Lectures for All Competitive Exams' },
      { title: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.' }
    ]
  };

  // Fallback for Reviews section
  const fallbackReviewsSection = {
    title: 'Client Testimonials',
    heading_text: 'REVIEWS',
    section_image: testimonialBg,
    section_image_2: messageIcon,
    section_review: {
      text: '4.9 / 5.0 Rated on App store',
      review_stars: '4.5'
    }
  };

  // Fallback for Story section
  const fallbackStorySection = {
    heading_text: 'About Us',
    title: 'A story of our successful 25 years',
    small_description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
    section_image: overviewElement,
    button_url: 'https://youtu.be/tgbNymZ7vqY',
    button_text: 'Intro Video',
    video_background: videoImg,
    sliders: [
      {
        year: 2001,
        image: aboutImg,
        title: 'Founded by Willium Smith',
        description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.'
      },
      {
        year: 2015,
        image: aboutImg,
        title: 'Founded by Willium Smith',
        description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.'
      },
      {
        year: 2018,
        image: aboutImg,
        title: 'Founded by Willium Smith',
        description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.'
      }
    ]
  };

  // Advert popup logic
  const { data: advertsData } = useAdverts({ position_key: 'about_us_popup', ad_format: 'popup', useWebContent: true });
  const [showAdvert, setShowAdvert] = useState(false);
  const [shownOnce, setShownOnce] = useState(false);

  useEffect(() => {
    if (!isLoading && advertsData?.dataset?.data?.length && !shownOnce) {
      setShowAdvert(true);
      setShownOnce(true);
    }
  }, [isLoading, advertsData, shownOnce]);

  const handleCloseAdvert = () => setShowAdvert(false);
  function getRandomAdvert(advertData) {
    const arr = advertData?.dataset?.data;
    if (Array.isArray(arr) && arr.length > 0) {
      const idx = Math.floor(Math.random() * arr.length);
      return arr[idx];
    }
    return undefined;
  }
  const popupAdvert = getRandomAdvert(advertsData);

  if (isLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}>
        <img
          src="https://stg-admin.gkcloud.in/storage/settings/backend_favicon_1739509041.png"
          alt="Loading..."
          style={{
            width: '100px',
            height: 'auto',
            animation: 'pulse 1.5s infinite'
          }}
        />
        <style>
          {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
        </style>
      </div>
    );
  }

  // End Modal Popup
  return (
    <>
      {/* === Banner Section === */}
       <section
        className="contact-banner about-banner" >
      <div className="svg-position svg-img aboutSVG">
         <AboutBannerSVG />
       <div className="svg-content w-100">
        {/* Floating Dots */}
        <div className="floating-dots">
          {[...Array(10)].map((_, i) => (
            <div className="dot" key={i}></div>
          ))}
        </div>

        <Container>
          <Row className="align-items-center">
            <div className="col-lg-12">
              <div
                className="section_title top_content text-center"
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="300"
              >
                {isLoading ? (
                  <>
                    <span className="title_badge mb-1">
                      <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                    </span>
                    <h2>
                      <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                    </h2>
                    <p className="mb-0">
                      <span className="shimmer" style={{ width: '500px', height: '20px' }} />
                    </p>
                  </>
                ) : isError || !aboutSection ? (
                  <>
                    <span className="title_badge mb-1">{fallbackAboutSection.heading_text}</span>
                    <h2>{fallbackAboutSection.title}</h2>
                    <p className="mb-0">{fallbackAboutSection.small_description}</p>
                  </>
                ) : (
                  <>
                    <span className="title_badge mb-1">{aboutSection.heading_text}</span>
                    <h2>{aboutSection.title}</h2>
                    <p className="mb-0">{aboutSection.small_description}</p>
                  </>
                )}
                <ul className="banner-nav">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <span>»</span>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </Row>
        </Container>
          </div>
        </div>
      </section>

      {/* Counter Section */}
      <Counter />
      {/* End Counter Section */}


      {/* Ceo Message Section */}
      <section className="ceo-banner">
        <Container
          className="ceo-bg svg-position" >
          <AboutCeoSVG/>
<div className="svg-content ceo-svg">
          <div className="element">
            <span className="element1">
              {/* <img src={element1} alt="Element 1" /> */}
                 <StarElementSVG/>
            </span>
            <span className="element2">
              {/* <img src={element2} alt="Element 2" /> */}
                 <StarElementSVG/>
            </span>
          </div>

          <Row>
            <div className="col-md-9">
              <div className="ceo-content">
                <div className="ceo-image">
                  {isLoading ? (
                    <span className="shimmer" style={{ width: '100%', height: '300px' }} />
                  ) : (
                    <img
                      src={isError || !ceoSection ? fallbackCeoSection.section_image : ceoSection.section_image}
                      alt="CEO"
                    />
                  )}
                </div>

                <div className="ceo-text">
                  {isLoading ? (
                    <>
                      <h5>
                        <span className="shimmer" style={{ width: '150px', height: '20px' }} />
                      </h5>
                      <h3>
                        <span className="shimmer" style={{ width: '400px', height: '30px' }} />
                      </h3>
                    </>
                  ) : isError || !ceoSection ? (
                    <>
                      <h5>{fallbackCeoSection.heading_text}</h5>
                      <p>{fallbackCeoSection.title}</p>
                    </>
                  ) : (
                    <>
                      <h5>{ceoSection.heading_text}</h5>
                      <p>{ceoSection.title}</p>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="ceo-img">
                <img src={clientReview} alt="Client Review" />
                {isLoading ? (
                  <>
                    <p>
                      <span className="shimmer" style={{ width: '150px', height: '20px' }} />
                    </p>
                    <p>
                      <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                    </p>
                  </>
                ) : isError || !ceoSection ? (
                  <>
                    <p>{fallbackCeoSection.section_review.text}</p>
                    <p>
                      <Link to={fallbackCeoSection.section_review.url}>
                        {fallbackCeoSection.section_review.link_text}
                      </Link>
                    </p>
                  </>
                ) : (
                  <>
                    <p>{ceoSection.section_review.text}</p>
                    <p>
                      <Link to={ceoSection.section_review.url}>
                        {ceoSection.section_review.link_text}
                      </Link>
                    </p>
                  </>
                )}
              </div>
            </div>
          </Row>
          </div>
        </Container>
      </section>
      {/* End Ceo Message Section */}

      {/* Company Overview Section */}
      <section className="company-overview margin-custom">
        <Container>
          <Row className="align-items-center">
            <div className="col-lg-6">
              <div className="overview">
                <div
                  className="section_title top_content"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-delay="300"
                >
                  {isLoading ? (
                    <>
                      <span className="title_badge mb-1 text-background">
                        <span className="shimmer" style={{ width: '150px', height: '20px' }} />
                      </span>
                      <h2>
                        <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                      </h2>
                      <p className="mb-0 company-text">
                        <span className="shimmer" style={{ width: '500px', height: '20px' }} />
                      </p>
                    </>
                  ) : isError || !companyOverviewSection ? (
                    <>
                      <span className="title_badge mb-1 text-background">
                        {fallbackCompanyOverviewSection.heading_text}
                      </span>
                      <h2>{fallbackCompanyOverviewSection.title}</h2>
                      <p className="mb-0 company-text">{fallbackCompanyOverviewSection.small_description}</p>
                    </>
                  ) : (
                    <>
                      <span className="title_badge mb-1 text-background">
                        {companyOverviewSection.heading_text}
                      </span>
                      <h2>{companyOverviewSection.title}</h2>
                      <p className="mb-0 company-text">{companyOverviewSection.small_description}</p>
                    </>
                  )}
                </div>
                <div className="viewmore-btn comapny-btn">
                  <Link
                    to={isError || !companyOverviewSection ? fallbackCompanyOverviewSection.button_url : companyOverviewSection.button_url}
                    className="btn get-btn"
                  >
                    {isLoading ? (
                      <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                    ) : isError || !companyOverviewSection ? (
                      fallbackCompanyOverviewSection.button_text
                    ) : (
                      companyOverviewSection.button_text
                    )}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="company-img">
                {isLoading ? (
                  <span className="shimmer" style={{ width: '100%', height: '300px' }} />
                ) : (
                  <img
                    src={isError || !companyOverviewSection ? fallbackCompanyOverviewSection.section_image : companyOverviewSection.section_image}
                    alt="Company Overview"
                    className="w-100"
                  />
                )}
              </div>
            </div>
          </Row>
        </Container>
      </section>
      {/* End Company Overview Section */}

      {/* Core Value */}
      <section className="core-value">
        <Container>
          <div className="core-value-block">
            <Row>
              {isLoading ? (
                [...Array(3)].map((_, index) => (
                  <div className="col-md-4" key={index}>
                    <div
                      className="core-content"
                      data-aos="fade-left"
                      data-aos-duration={1500 + index * 300}
                    >
                      <span className="shimmer" style={{ width: '100px', height: '100px' }} />
                      <div className="core-text">
                        <h5>
                          <span className="shimmer" style={{ width: '150px', height: '20px' }} />
                        </h5>
                        <p className="mb-0">
                          <span className="shimmer" style={{ width: '250px', height: '20px' }} />
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                coreValues.map((value, index) => (
                  <div className="col-md-4" key={index}>
                    <div
                      className="core-content"
                      data-aos="fade-left"
                      data-aos-duration={1500 + index * 300}
                    >
                      <img src={value.image} alt={value.title} />
                      <div className="core-text">
                        <h5>{value.title}</h5>
                        <p className="mb-0">{value.description}</p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </Row>
          </div>
        </Container>
      </section>
      {/* End Core Value */}

      {/* Why we are best Section */}
      <section className="company-overview margin-custom">
        <Container>
          <Row className="align-items-center">
            <div className="col-lg-6">
              <div className="company-img">
                {isLoading ? (
                  <span className="shimmer" style={{ width: '100%', height: '300px' }} />
                ) : (
                  <img
                    src={isError || !whyBestSection ? fallbackWhyBestSection.section_image : whyBestSection.section_image}
                    alt=""
                    className="w-100"
                  />
                )}
              </div>
            </div>

            <div className="col-lg-6">
              <div className="overview why-best">
                <div className="section_title top_content"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-delay="300">
                  {isLoading ? (
                    <>
                      <span className="title_badge mb-1 text-background">
                        <span className="shimmer" style={{ width: '150px', height: '20px' }} />
                      </span>
                      <h2>
                        <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                      </h2>
                      <p className="mb-0 company-text">
                        <span className="shimmer" style={{ width: '500px', height: '20px' }} />
                      </p>
                    </>
                  ) : isError || !whyBestSection ? (
                    <>
                      <span className="title_badge mb-1 text-background">
                        {fallbackWhyBestSection.heading_text}
                      </span>
                      <h2>{fallbackWhyBestSection.title}</h2>
                      <p className="mb-0 company-text">{fallbackWhyBestSection.small_description}</p>
                    </>
                  ) : (
                    <>
                      <span className="title_badge mb-1 text-background">
                        {whyBestSection.heading_text}
                      </span>
                      <h2>{whyBestSection.title}</h2>
                      <p className="mb-0 company-text">{whyBestSection.small_description}</p>
                    </>
                  )}

                  <ul className="content-list best-list">
                    {/* FIX: Added !Array.isArray check to prevent .map on non-arrays */}
                    {(isLoading ? [...Array(3)] : (isError || !whyBestSection || !Array.isArray(whyBestSection.sliders) ? fallbackWhyBestSection.sliders : whyBestSection.sliders)).map((item, index) => (
                      <li key={index}>
                        <span className="d-flex">
                          {/* <img src={checkIcon} alt="" /> */}

                          <AboutCheckSVG/>

                        </span>
                        {isLoading ? (
                          <span className="shimmer" style={{ width: '200px', height: '20px' }} />
                        ) : (
                          item.title
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="viewmore-btn comapny-btn">
                  <Link
                    to={isError || !whyBestSection ? fallbackWhyBestSection.button_url : whyBestSection.button_url}
                    className="btn get-btn"
                  >
                    {isLoading ? (
                      <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                    ) : isError || !whyBestSection ? (
                      fallbackWhyBestSection.button_text
                    ) : (
                      whyBestSection.button_text
                    )}
                  </Link>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </section>
      {/* End Why we are best Section  */}

      {/* Client Testimonial Section */}
      <section className="testimonial-section client-testimonial position-relative" style={{
        backgroundImage: `url(${testimonialBg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        paddingTop: '100px',
        paddingBottom: '100px',
        margin: 'auto',
        borderRadius: '20px',
        position: 'relative',
      }}>

        {/* Rated Block */}
        <div className="rated-block text-center">
          {/* Star Icon */}
          <div className="star">
            {[...Array(5)].map((_, i) => (
              <span key={i}>
                <i className="fa-solid fa-star" aria-hidden="true"></i>
              </span>
            ))}
          </div>
          {/* End Star Icon */}
          <span className="title_badge mb-1 text-background">
            {isLoading ? (
              <span className="shimmer" style={{ width: '200px', height: '20px' }} />
            ) : isError || !reviewsSection ? (
              fallbackReviewsSection.section_review.text
            ) : (
              reviewsSection.section_review.text
            )}
          </span>
        </div>
        {/* Rated Block */}

        <div className="position-relative">
          <div className="element">
            <span className="element1">
              <img
                src={isLoading ? messageIcon : (isError || !reviewsSection ? fallbackReviewsSection.section_image : reviewsSection.section_image)}
                alt=""
              />
            </span>
            <span className="element2">
              <img
                src={isLoading ? thumbIcon : (isError || !reviewsSection ? fallbackReviewsSection.section_image_2 : reviewsSection.section_image_2)}
                alt=""
              />
            </span>
          </div>
          <div className="container custom-container">
            <div className="section_title top_content text-center"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="300">
              <span className="title_badge mb-1 text-background">
                {isLoading ? (
                  <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                ) : isError || !reviewsSection ? (
                  fallbackReviewsSection.heading_text
                ) : (
                  reviewsSection.heading_text
                )}
              </span>
              <h2 className="dark-text">
                {isLoading ? (
                  <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                ) : isError || !reviewsSection ? (
                  fallbackReviewsSection.title
                ) : (
                  reviewsSection.title
                )}
              </h2>
            </div>

            {/*Testimonial Slider*/}
            <Testimonial />
            {/*End Testimonial Slider*/}
          </div>
        </div>
      </section>
      {/* End Client Testimonial Section */}

      {/* Company  Overview Section */}
      <section className="company-overview margin-custom about-block">
        <Container>
          <Row>
            <div className="col-md-6">
              <div className="about-story">
                <div
                  className="section_title top_content aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-delay="300"
                >
                  {isLoading ? (
                    <>
                      <span className="title_badge mb-1 text-background">
                        <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                      </span>
                      <h2 style={{ color: '#32236F', fontWeight: 800 }}>
                        <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                      </h2>
                      <p className="mb-0 company-text">
                        <span className="shimmer" style={{ width: '500px', height: '20px' }} />
                      </p>
                    </>
                  ) : isError || !storySection ? (
                    <>
                      <span
                        className="title_badge mb-1 text-background">
                        {fallbackStorySection.heading_text}
                      </span>
                      <h2 style={{ color: '#32236F', fontWeight: 800 }}>
                        {fallbackStorySection.title}
                      </h2>
                      <p className="mb-0 company-text">
                        {fallbackStorySection.small_description}
                      </p>
                    </>
                  ) : (
                    <>
                      <span
                        className="title_badge mb-1 text-background">
                        {storySection.heading_text}
                      </span>
                      <h2  className="dark-text" style={{ fontWeight: 800 }}>
                        {storySection.title}
                      </h2>
                      <p className="mb-0 company-text">
                        {storySection.small_description}
                      </p>
                    </>
                  )}
                </div>

                {/* Element */}
                <div className="element about-element">
                  <span className="element1">
                    {/* <img src={overviewElement} alt="" /> */}
                       <StarElementSVG/>
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="about-box">
                {/* FIX: Added !Array.isArray check to prevent .map on non-arrays */}
                {(isLoading ? [...Array(3)] : (isError || !storySection || !Array.isArray(storySection.sliders) ? fallbackStorySection.sliders : storySection.sliders)).map((item, index) => (
                  <div className="about" key={index}>
                    <div className="about-image">
                      {isLoading ? (
                        <span className="shimmer" style={{ width: '100%', height: '100px' }} />
                      ) : (
                        <img src={item.image} alt="" />
                      )}
                    </div>
                    <div className="about-text">
                      {isLoading ? (
                        <>
                          <span className="title_badge mb-1 text-background">
                            <span className="shimmer" style={{ width: '50px', height: '20px' }} />
                          </span>
                          <h4 className="mb-0">
                            <span className="shimmer" style={{ width: '200px', height: '20px' }} />
                          </h4>
                          <p className="mb-0">
                            <span className="shimmer" style={{ width: '250px', height: '20px' }} />
                          </p>
                        </>
                      ) : (
                        <>
                          <span className="title_badge mb-1 text-background">{item.year}</span>
                          <h4 className="mb-0">{item.title}</h4>
                          <p className="mb-0">{item.description}</p>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Row>
        </Container>
      </section>
      {/* Company  Overview Section */}

      {/* About Video Section */}
      <section className="about-video">
        <Container className="download-container">
          <Row>
            <div className="col-md-12 video-content">
              <img
                src={isLoading ? videoImg : (isError || !storySection ? fallbackStorySection.video_background : storySection.section_image)}
                className="video-background"
                alt=""
              />
              <button type="button" className="about-playbtn" onClick={openModal}>
                <div className="intro-img">
                  {/* <img src={playButton} alt="" /> */}
                 <AboutVideoSVG/>
                  <div className="waves-block">
                    <div className="waves wave-1"></div>
                    <div className="waves wave-2"></div>
                    <div className="waves wave-3"></div>
                  </div>
                </div>
                <span className="title_badge mb-1 text-background">
                  {isLoading ? (
                    <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                  ) : isError || !storySection ? (
                    fallbackStorySection.button_text
                  ) : (
                    storySection.button_text
                  )}
                </span>
                <h4>
                  {isLoading ? (
                    <span className="shimmer" style={{ width: '300px', height: '20px' }} />
                  ) : isError || !storySection ? (
                    fallbackStorySection.title
                  ) : (
                    storySection.title
                  )}
                </h4>
              </button>
            </div>
          </Row>

          {/* React Modal */}
          {showModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: 1050,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content" style={{ background: 'transparent' }}>
                  <div className="button-block text-end ">
                    <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                  </div>
                  <div className="modal-body p-0">
                    <div className="video-container w-100">
                      <iframe
                        id="videoFrame"
                        src={`https://www.youtube.com/embed/${isError || !storySection ? fallbackStorySection.button_url.split('/').pop() : storySection.button_url.split('/').pop()}?autoplay=1&mute=1`}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        width="100%"
                        height="500"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Container>
      </section>
      {/*End About Video Section*/}

      {/* Expert Leaders Section */}
      <section className="expert-leaders">
        <Container>
          <div
            className="section_title top_content text-center"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="300"
          >
            {isLoading ? (
              <>
                <span className="title_badge mb-1">
                  <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                </span>
                <h2>
                  <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                </h2>
                <p className="mb-0">
                  <span className="shimmer" style={{ width: '500px', height: '20px' }} />
                </p>
              </>
            ) : isError || !teamMembersSection ? (
              <SectionHeading
                title={fallbackTeamMembersSection.title}
                subtitle={fallbackTeamMembersSection.small_description}
                badgeText={fallbackTeamMembersSection.heading_text}
              />
            ) : (
              <SectionHeading
                title={teamMembersSection.title}
                subtitle={teamMembersSection.small_description}
                badgeText={teamMembersSection.heading_text}
              />
            )}
          </div>

          <Row>
            <div className="col-md-12">
              {/* FIX: Ensure team_members is always an array before passing */}
              <ExpertLeaderTestimonial teamMembers={Array.isArray(teamMembersSection?.team_members) ? teamMembersSection?.team_members : fallbackTeamMembersSection.team_members} />
            </div>
          </Row>
        </Container>
      </section>
      {/* End Expert Leaders Section */}

      {/* End Expert Leaders Section */}

      {/* Download App Section */}
      <section className="download-app about-download">
        <Container className="download-container">
        <div className="svg-position svg-img">
 <DownloadAppSVG/>
<div className="download-content svg-content">
            <div className="element">
              <span className="element1">
                {/* <img src={element5} alt="Element 1" /> */}
                   <StarElementSVG/>
              </span>
              <span className="element2">
                {/* <img src={element5} alt="Element 2" /> */}
                   <StarElementSVG/>
              </span>
            </div>
            <Row className="align-items-center">
              <div className="col-md-6">
                <div className="keynotes-section">
                  {isLoading ? (
                    <>
                      <span className="title_badge mb-1" >
                        <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                      </span>
                      <h2>
                        <span className="shimmer" style={{ width: '300px', height: '40px' }} />
                      </h2>
                      <p className="mb-0">
                        <span className="shimmer" style={{ width: '500px', height: '20px' }} />
                      </p>
                    </>
                  ) : isError || !downloadAppSection ? (
                    <SectionHeading
                      title={fallbackDownloadAppSection.title}
                      subtitle={fallbackDownloadAppSection.small_description}
                      badgeText={fallbackDownloadAppSection.heading_text}
                    />
                  ) : (
                    <SectionHeading
                      title={downloadAppSection.title}
                      subtitle={downloadAppSection.small_description}
                      badgeText={downloadAppSection.heading_text}
                    />
                  )}
                  <div className="app-buttons dwn-btns">
                    {/* FIX: Added !Array.isArray check to prevent .map on non-arrays */}
                    {(isLoading ? [{}, {}] : (isError || !downloadAppSection || !Array.isArray(downloadAppSection.buttons) ? fallbackDownloadAppSection.buttons : downloadAppSection.buttons)).map((button, index) => (
                      <a
                        key={index}
                        href={isLoading ? '#' : button.url || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={isLoading ? 'Loading...' : button.text}
                      >
                        {isLoading ? (
                          <span className="shimmer" style={{ width: '150px', height: '50px' }} />
                        ) : (
                          <img src={button.image} alt={button.text} />
                        )}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="download-img">
                  {isLoading ? (
                    <span className="shimmer" style={{ width: '100%', height: '400px' }} />
                  ) : (
                    <img
                      src={isError || !downloadAppSection ? fallbackDownloadAppSection.section_image : downloadAppSection.section_image}
                      alt="Download App"
                      className="w-100"
                    />
                  )}
                </div>
              </div>
            </Row>
            </div>
          </div>
        </Container>
      </section>
      {/* End Download App Section */}
      <AdvertPopup
        advert={popupAdvert}
        show={showAdvert}
        onClose={handleCloseAdvert}
        position_key="about_us_popup"
        useWebContent={true}
      />

    </>
  );
};

export default About;

